export const chatSelector = state => state.chat; // fix was here
